import React, { useEffect, useState } from 'react';
import { useSelector/* , useDispatch */ } from 'react-redux';
import { RootState/* , MyThunkDispatch */ } from 'store';

/* import { fetchHasAccess } from 'actions/accessLog'; */
import useStoreTranslation from 'hooks/useStoreTranslation';
import useToast from 'hooks/useToast';
import BreakRulesReasonList from 'screens/components/BreakRulesReasonList';
import { TravelReason } from 'models/travelReseller';
import { getBreakRulesReasonList } from 'services/resellerTravel';

const BreakRulesReasonContainer = () => {
  /* const dispatch: MyThunkDispatch = useDispatch(); */
  const [breakRulesReasonList, setBreakRulesReasonList] = useState<TravelReason[]>([]);
  const [isLoading, setLoading] = useState(false);
  const toast = useToast();
  const { t } = useStoreTranslation();
  /* estados globales */
  const companyId = useSelector((state: RootState) => state.user.accountResult?.companyId);
  /* const adminId = useSelector((state: RootState) => (state.user.accountResult ? state.user.accountResult?.id : '')); */
  const tourLoading = useSelector((state: RootState) => state.accessLog.isLoading);
  /* const hasAccess = useSelector((state: RootState) => state.accessLog.ListGroups); */

  /*   useEffect(() => {
    const screenName = 'ListGroups';
    dispatch(fetchHasAccess(screenName));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adminId]); */

  const getData = async () => {
    setLoading(true);
    try {
      const data = await getBreakRulesReasonList();
      setBreakRulesReasonList(
        data.map((travel: TravelReason) => ({
          id: travel.id,
          isFromReseller: false,
          name: travel.name,
        })),
      );
    } catch (error) {
      toast.add({
        type: 'danger',
        message: t('group.groupAggregation.errorFetch'),
      });
      setLoading(false);
    }
    setLoading(false);
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId]);

  const onConfirmSelection = (breaRulesReason: TravelReason) => {};

  return (
    <BreakRulesReasonList
      breakRulesReasonList={breakRulesReasonList}
      setBreakRulesReasonList={setBreakRulesReasonList}
      isLoading={isLoading}
      onConfirmSelection={onConfirmSelection}
      onDeleteSuccess={getData}
      tourLoading={tourLoading}
    />
  );
};

export default BreakRulesReasonContainer;
